<div
  (click)="closeMobileMenu($event)"
  [ngClass]="{
    'pointer-events-auto': menuService.showMobileMenu,
    'pointer-events-none': !menuService.showMobileMenu,
  }"
  class="fixed inset-0 z-50 md:hidden">
  <div
    [ngClass]="{
      'opacity-50': menuService.showMobileMenu,
      'opacity-0': !menuService.showMobileMenu,
    }"
    class="fixed inset-0 bg-black transition-opacity duration-300 ease-in-out"></div>

  <div
    (click)="$event.stopPropagation()"
    [ngClass]="{
      'translate-x-0': menuService.showMobileMenu,
      '-translate-x-full': !menuService.showMobileMenu,
    }"
    class="absolute left-0 top-0 h-full w-4/5 max-w-xs transform bg-white shadow-lg transition-transform duration-300 ease-in-out">
    <div class="flex h-[72px] items-center justify-between border-b">
      <app-logo class="pl-5" />
      <button
        (click)="menuService.showMobileMenu = false"
        appButton
        class="mr-4 flex h-8 w-8 items-center justify-center text-content-tertiary transition-all duration-200 hover:bg-gray-100 hover:text-muted-foreground focus:outline-none md:hidden"
        variant="link">
        <app-icon class="flex items-center justify-center text-content-secondary" name="cancel_01" size="1em" />
      </button>
    </div>

    <div class="h-[calc(100%-64px)] overflow-y-auto pb-20">
      <div
        [ngClass]="{
          'translate-y-0 opacity-100': menuService.showMobileMenu,
          'translate-y-4 opacity-0': !menuService.showMobileMenu,
        }"
        class="transition-all delay-150 duration-500 ease-out">
        <div class="flex w-full flex-col gap-2 border-b border-gray-200 p-5 pb-0 pt-2">
          <app-tenant-logado-navbar />
          <app-usuario-logado-mobile-sidebar />
        </div>
        <app-menu-content (menuItemClicked)="onMenuItemClick()" [expanded]="true" [isMobile]="true" />
      </div>
    </div>
  </div>
</div>
